<script setup lang="ts">
import {ChevronLeft, VideoOff} from "@lucide/vue";

/** A playable source resolved from the gift video (file = stock MP4, youtube = embed URL). */
export interface GiftVideoSource {
    type: 'file' | 'youtube';
    url: string;
}

defineProps<{
    /** Null when the video exists but cannot be played in the preview. */
    source: GiftVideoSource | null;
}>();

const emit = defineEmits<{
    (e: 'back'): void;
}>();
</script>

<template>
  <div class="flex flex-1 flex-col bg-[#f4f7fc]">
    <div class="flex shrink-0 items-center border-b border-gray-light bg-white px-1.5 py-2">
      <button
        type="button"
        class="flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium text-primary transition-colors hover:bg-primary-lightest"
        @click="emit('back')"
      >
        <ChevronLeft class="h-4 w-4" />
        Retour au message
      </button>
    </div>

    <div class="flex flex-1 items-center justify-center bg-black">
      <video
        v-if="source?.type === 'file'"
        :src="source.url"
        controls
        autoplay
        class="w-full"
      />
      <iframe
        v-else-if="source?.type === 'youtube'"
        :src="source.url"
        class="aspect-video w-full border-0"
        title="Vidéo d'anniversaire"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowfullscreen
      />
      <div
        v-else
        class="flex flex-col items-center gap-2 px-6 text-center text-xs text-white/75"
      >
        <VideoOff class="h-6 w-6" />
        Cette vidéo ne peut pas être lue dans l'aperçu.
      </div>
    </div>
  </div>
</template>
